lmApp.directive('lmEditSeason', [function () {
  return {
    restrict: 'E',
    controller: 'LmEditSeasonController',
    replace: true,
    templateUrl: 'lm-asset-edit/season/edit-season.tpl.html'
  };
}]);

lmApp
  .controller('LmEditSeasonController', ['$scope', '$rootScope', '$templateCache', '$compile', '$q', '$timeout', 'MetadataService', 'AssetService', 'ToastService', 'AssetResource', 'ValidatorService',
    function ($scope, $rootScope, $templateCache, $compile, $q, $timeout, MetadataService, AssetService, ToastService, AssetResource, ValidatorService) {
      $scope.season = {
        id: 0,
        extid: '',
        type: 'season',
        name: '',
        description: '',
        poster: {
          state: '',
          url: '',
          source: ''
        },
        seriesId: 0,
        index: 0
      };

      var saved = {};

      $scope.season.seriesId = $scope.asset.seriesId;
      if ($scope.asset.id && $scope.asset.id > 0) {
        $scope.season.id = $scope.asset.id;
        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var params = {};
        params['id[eq]'] = $scope.asset.id;
        params['$expand'] = 'resources(url)';
        AssetResource.get(params).$promise
            .then(function (result) {
              if (result.length) {
                processAsset(result[0]);
                saved = angular.copy(result[0]);
              } else {
                ToastService.Small({
                  title: 'Error getting season',
                  color: 'red',
                  icon: 'cloud-check'
                }, 1000 * 6);
                $scope.close();
              }
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;
            })
            .catch(function (reason) {
              ToastService.Small({
                title: 'Error getting season',
                color: 'red',
                icon: 'cloud-check'
              }, 1000 * 6);
              $rootScope.hideLinearProgress('#modalLoader');
              $scope.$parent.loading = false;
              $scope.close();
            });
      }

      var processAsset = function(asset) {
        $scope.season.extid = asset.ext_id;
        $scope.season.name = asset.name;
        $scope.season.description = asset.description;
        $scope.season.index = asset.season_index;
        if (asset.resources) {
          // find poster
          var posters = asset.resources.filter(function (resource) {
            return resource.type === 'picture';
          });
          if (posters.length > 0) {
            $scope.season.poster.state = posters[0].state;
            $scope.season.poster.url = posters[0].url;
            $scope.season.poster.source = posters[0].source;
          }
        }
      };

        var normSeasonToJson = function(season) {
            var processed = {
                ext_id: 'personal:' + translit(season.name) + (season.index || '') + ':' + CryptoJS.MD5(season.name + (season.index || '')).toString(CryptoJS.enc.Hex) + ':' + guid(),
                type: 'season',
                name: _.trim(season.name),
                description: _.trim(season.description),
                season_index: parseInt(season.index),
                resources: []
            };
            if (season.poster.source) {
                processed.resources.push({
                    type: 'picture',
                    category: 'poster_blueprint',
                    group_id: 'picture',
                    source: season.poster.source,
                    preparer: 'passthrough',
                    deployer: 'origin'
                });
            }
            return processed;
        };

        var isAssetValid = function() {
            $scope.seasonValidateErrors = {};

            var valid = true;
            if (!_.trim($scope.season.name)) {
                $scope.seasonValidateErrors.name = true;
                valid = false;
            }
            if (!ValidatorService.Numerical($scope.season.index) || $scope.season.index < 0) {
                $scope.seasonValidateErrors.index = true;
                valid = false;
            }
            return valid;
        };

        $scope.$parent.createFn = function () {
            if (!isAssetValid()) return;

            $rootScope.showLinearProgress('#modalLoader');
            $scope.$parent.loading = true;

            AssetResource.createSeason({id: $scope.season.seriesId}, normSeasonToJson($scope.season)).$promise
                .then(function (response) {
                    ToastService.Small({
                        title: 'VOD: <b class="tc-white">' + $scope.season.name + '</b> successfully created',
                        color: 'green',
                        icon: 'cloud-check'
                    }, 1000 * 6);

                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.$parent.loading = false;

                    $scope.close(-1);

                })
                .catch(function (reason) {
                    $rootScope.showLinearProgress('#modalLoader');
                    $scope.$parent.loading = true;
                    $scope.close();
                    ToastService.Small({
                        title: 'Failed to create asset: ' + _.get(reason, 'data.error.message', 'server error'),
                        color: 'red',
                        icon: 'delete'
                    }, 30 * 1000);
                });
        };

        var compareResources = function(updated) {
            var sourceResourceMap = {};
            if (saved.resources) {
                for (var i = 0; i < saved.resources.length; i++) {
                    var r = saved.resources[i];
                    var key = r.type + r.category;
                    sourceResourceMap[key] = r;
                }
            }

            var newResources = [];
            for (var i = 0; i < updated.resources.length; i++) {
                var r = updated.resources[i];
                var key = r.type + r.category;
                if (!sourceResourceMap.hasOwnProperty(key)) {
                    newResources.push(r);
                } else {
                    if (r.source === sourceResourceMap[key].source
                        && r.private === sourceResourceMap[key].private
                        && r.deployer === sourceResourceMap[key].deployer
                        && sourceResourceMap[key].state !== 'deployment-error') {
                        newResources.push(sourceResourceMap[key]);
                    } else {
                        newResources.push(r);
                    }
                }
            }
            return newResources;
        };

        $scope.$parent.updateFn = function (asset) {
            if (!isAssetValid()) return;

            $rootScope.showLinearProgress('#modalLoader');
            $scope.$parent.loading = true;

            var updated = normSeasonToJson($scope.season);
            updated.resources = compareResources(updated);

            AssetResource.update({id: $scope.season.id}, updated).$promise
                .then(function (response) {
                    ToastService.Small({
                        title: 'VOD: <b class="tc-white">' + $scope.season.name + '</b> successfully updated',
                        color: 'green',
                        icon: 'cloud-check'
                    }, 1000 * 6);

                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.$parent.loading = false;

                    $scope.close(-1);

                })
                .catch(function (reason) {
                    $rootScope.showLinearProgress('#modalLoader');
                    $scope.$parent.loading = true;
                    ToastService.Small({
                        title: 'Failed to update asset: ' + _.get(reason, 'data.error.message', 'server error'),
                        color: 'red',
                        icon: 'cloud-outline-off'
                    }, 30 * 1000);
                    $rootScope.debugInfo(reason);
                });
        }

  }]);
